export default import.meta.ROLLDOWN_FILE_URL_$2eRv__X3S5V0lx7rBQ6KA